import { gql } from "@apollo/client";

export const GET_ALL_CARRIER_OPTIONS = gql`
    query GetAllCarrierOptions {
        getAllCarrierOptions {
            value
            name
        }
    }
`;

export interface CarrierOption {
    value: number;
    name: string;
}

export interface GetAllCarrierOptionsResponse {
    getAllCarrierOptions: CarrierOption[];
}

